import { Link } from 'react-router-dom'
import type { MyPlanningSummary } from '@crm/shared'
import {
  formatPlanRub,
  formatRub,
  monthLabel,
  percentText,
  progressColor,
} from './manager/planFactFormat'

/**
 * План и факт текущего месяца на карточке менеджера в главной помощника
 * (29.09.2026, обращение помощника «Статус оборота менеджера», заказчик
 * одобрил). Те же цифры, что менеджер видит у себя в блоке «План и факт»;
 * клик ведёт в «Планирование» (у помощника — только просмотр).
 */
export function AssistantManagerPlan({ plan }: { plan: MyPlanningSummary }) {
  const { planAmount, factAmount, quotedAmount, orderedAmount } = plan
  const ratio = planAmount > 0 ? factAmount / planAmount : 0
  const widthPct = Math.min(100, Math.round(ratio * 100))

  return (
    <Link
      to="/planning"
      className="block rounded-lg border border-gray-100 dark:border-gray-800 px-2.5 py-2 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
      title="Открыть «Планирование»"
    >
      <div className="flex items-baseline justify-between gap-2 text-xs">
        <span className="text-gray-500">
          План и факт · <span className="capitalize">{monthLabel(plan.periodMonth)}</span>
        </span>
        <span className="font-semibold tabular-nums text-gray-900">
          {percentText(planAmount, factAmount)}
        </span>
      </div>
      {planAmount > 0 ? (
        <>
          <div className="mt-1.5 h-2 w-full rounded-full bg-gray-100 overflow-hidden">
            <div
              className={`h-full rounded-full ${progressColor(ratio)}`}
              style={{ width: `${widthPct}%` }}
            />
          </div>
          <div className="mt-1 text-[11px] text-gray-500 tabular-nums">
            Факт {formatPlanRub(factAmount)} из {formatPlanRub(planAmount)}
          </div>
        </>
      ) : (
        <div className="mt-1 text-[11px] text-gray-400">План на месяц не задан</div>
      )}
      <div className="mt-1 flex flex-wrap justify-between gap-x-2 text-[11px] text-gray-400 tabular-nums">
        <span>КП выставлено: {formatRub(quotedAmount)}</span>
        <span>В заказ: {formatRub(orderedAmount)}</span>
      </div>
    </Link>
  )
}
